import React from "react";
import { ThemeIcon } from "@mantine/core";

type ArticleIconProps = {
  ariaLabel: string;
  icon: any;
};

const ArticleIcon = ({ ariaLabel, icon }: ArticleIconProps) => {
  return (
    <ThemeIcon c={"white"} size="md" variant="filled" aria-label={ariaLabel}>
      {React.cloneElement(icon, { size: 24 })} {/* Apply default size */}
    </ThemeIcon>
  );
};

export default ArticleIcon;
